import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حساب طول قطر المربع";
const DESCRIPTION =
  "استخدم حاسبة قطر المربع لحساب قطر المربع بسهولة ودقة. أدخل طول الضلع للحصول على القطر باستخدام الصيغة المناسبة.";
const KEYWORDS =
  "حاسبة قطر المربع, حساب قطر المربع, الهندسة, الرياضيات, طول الضلع, القطر, الجذر التربيعي";
const OG_URL =
  "https://do-calculate.com/calculator/ar/square-diameter-calculator/";
function SquareDiameterCalculator() {
  const [sideLength, setSideLength] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [steps, setSteps] = useState([]);
  const handleCalculate = () => {
    try {
      if (!sideLength) {
        setError("يرجى إدخال طول الضلع.");
        return;
      }
      const sqrt2 = Math.sqrt(2);
      const diameter = sqrt2 * parseFloat(sideLength);
      const calculationSteps = [
        `الجذر التربيعي للرقم ٢ = ${sqrt2.toFixed(2)}`,
        `طول الضلع = ${sideLength} سم`,
        `القطر = ${sqrt2.toFixed(2)} × ${sideLength} = ${diameter.toFixed(
          2
        )} سم`,
      ];
      setResult(diameter.toFixed(2));
      setSteps(calculationSteps);
      setError("");
    } catch (err) {
      setError("حدث خطأ أثناء الحساب. يرجى المحاولة مرة أخرى.");
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  هل تحتاج إلى حساب قطر مربع بسرعة ودقة؟ حاسبتنا الذكية هي الحل
                  الأمثل لك! باستخدام المعادلة الرياضية الصحيحة، تقوم حاسبتنا
                  بحساب قطر المربع بناءً على طول ضلعه.{" "}
                </p>
                <p>
                  كل ما عليك هو إدخال طول ضلع المربع في الحقل المخصص، وستحصل على
                  النتيجة فوراً. لا داعي للقلق بشأن الحسابات المعقدة، فحاسبتنا
                  تتولى كل شيء نيابة عنك.
                </p>
                <p>
                  <strong>
                    قطر المربع = الجذر التربيعي للرقم ٢ × طول الضلع
                  </strong>
                </p>
                <ul>
                  <li>أدخل طول الضلع لحساب قطر المربع.</li>
                </ul>
                <p>
                  تم تطوير هذه الحاسبة لتسهيل عملية حساب قطر المربع وضمان الدقة
                  في الحسابات.
                </p>
                <hr />
              </div>
              <br />
            </div>
                <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="sideLength">
                        أدخل طول الضلع (سم)
                      </label>
                      <input
                        id="sideLength"
                        type="number"
                        value={sideLength}
                        onChange={(e) => setSideLength(e.target.value)}
                        placeholder="أدخل طول الضلع"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">النتيجة:</h4>
                      <p className="text-white">{result} سم</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4>الخطوات:</h4>
                        <ul>
                          {steps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">ما هو قطر المربع؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مفهوم قطر المربع</h2>
                  </u>
                  <p>
                    قطر المربع هو المسافة بين أي زاويتين متقابلتين داخل المربع.
                    يُستخدم حساب قطر المربع في العديد من التطبيقات الهندسية
                    والرياضية.
                  </p>
                  <ul>
                    <li>
                      <strong>
                        قطر المربع = الجذر التربيعي للرقم ٢ × طول الضلع
                      </strong>
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: إذا كان طول الضلع 5 سم، فإن قطر المربع يساوي: √2 × 5 ≈
                    7.07 سم
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيفية حساب قطر المربع</h2>
                  </u>
                  <p>لحساب قطر المربع، اتبع الخطوات التالية:</p>
                  <ul>
                    <li>أدخل طول الضلع في الصيغة المناسبة.</li>
                    <li>
                      استخدم الجذر التربيعي للرقم ٢ مع طول الضلع لحساب القطر.
                    </li>
                    <li>تأكد من أن القيمة المدخلة صحيحة ودقيقة.</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: إذا كان طول الضلع 7 سم، فإن قطر المربع يساوي: √2 × 7 ≈
                    9.9 سم
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسئلة الشائعة</h2>
                  </u>
                  <p>إجابات لبعض الأسئلة الشائعة حول قطر المربع وحسابه.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    سؤال: لماذا نستخدم الجذر التربيعي للرقم ٢ في حساب قطر
                    المربع؟
                    <br />
                    جواب: الجذر التربيعي للرقم ٢ يعكس العلاقة بين طول الضلع
                    والقطر في المربع، حيث يربط القطر بين زاويتين متقابلتين.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default SquareDiameterCalculator;
